import { createStore } from "vuex";

import exercises from "./modules/exercises";
import blog from "./modules/blog";
import loadings from "./modules/loadings";
import notifications from "./modules/notifications";
import users from "./modules/users";
import subscriptions from "./modules/subscriptions";
import classes from "./modules/classes";
import homeworks from "./modules/homeworks";
import chapters from "./modules/chapters";
import administration from "./modules/administration";
import schools from "./modules/schools";
import contactForm from "./modules/contactForm";
import bugsTracker from "./modules/bugsTracker";
import pagination from "./modules/pagination";
import teachers from "./modules/teachers";
import students from "./modules/students";
import countries from "./modules/countries";
import garSubcriptions from "./modules/garSubcriptions";
import tabuleoSubscriptions from "./modules/tabuleoSubscriptions";
import locales from "./modules/locales";
import garResource from "./modules/garResource";
import resources from "./modules/resources";
import levels from "./modules/levels";
import propositions from "./modules/propositions";
import mockExamTemplates from "./modules/mockExamTemplates";
import gradingSystems from "./modules/gradingSystems";
import sessions from "./modules/sessions";
import broadcastChannel from "./modules/broadcastChannel";
import globalParameters from "./modules/globalParameters";

export default createStore({
  modules: {
    exercises,
    blog,
    loadings,
    notifications,
    users,
    subscriptions,
    classes,
    homeworks,
    chapters,
    administration,
    schools,
    contactForm,
    bugsTracker,
    pagination,
    teachers,
    students,
    countries,
    garSubcriptions,
    tabuleoSubscriptions,
    locales,
    garResource,
    resources,
    levels,
    propositions,
    mockExamTemplates,
    gradingSystems,
    sessions,
    broadcastChannel,
    globalParameters,
  },
});
